'use client'

import { createContext, useContext, type RefObject } from 'react'

export interface SendJourneyContextValue {
  /** True once the scroll journey is active (desktop viewport, motion allowed, hydrated). */
  enabled: boolean
  /** True while the mock has arrived at the dock — drives confetti and the link-ready reveal. */
  docked: boolean
  heroSlotRef: RefObject<HTMLDivElement | null>
  dockSlotRef: RefObject<HTMLDivElement | null>
}

export const SendJourneyContext = createContext<SendJourneyContextValue | null>(null)

export function useSendJourney(): SendJourneyContextValue | null {
  return useContext(SendJourneyContext)
}
